<template>
  <div class="account-center-applying">
    <div
      class="button-container mb-3 text-left"
      v-show="selectedList.length > 0"
    >
      <!-- :class="{'hidden': selectedList.length > 0}" -->
      <b-button
        class="mr-3"
        type="button"
        variant="primary"
        @click="summitVerifyEmail"
        >發送核准信</b-button
      >
      <b-button class="mr-3" type="button" variant="dark" @click="clearSelected"
        >取消</b-button
      >
    </div>
    <b-table
      ref="selectableTable"
      selectable
      :select-mode="'multi'"
      @row-selected="onRowSelected"
      :fields="fields"
      :items="$store.getters.applyingUsers"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      sort-icon-left
      sticky-header
      head-variant="dark"
      hover
      small
      striped
    >
      <template v-slot:cell(account)="{ item }">
        <a @click="toUserDetail(item)">{{ item.account }}</a>
      </template>
      <template v-slot:cell(reject_btn)="{ item }">
        <button @click="summit(item)">黑名單</button>
      </template>
    </b-table>
    <tableListNoData
      v-if="$store.getters.applyingUsers.length === 0"
    ></tableListNoData>
  </div>
</template>

<script>
import tableListNoData from "@/components/TableListNoData.vue";
export default {
  components: {
    tableListNoData
  },
  data() {
    return {
      sortBy: "created_at",
      sortDesc: false,
      fields: [
        { key: "account", label: "帳號", sortable: true },
        { key: "name", label: "姓名", sortable: true },
        { key: "email", label: "信箱", sortable: true },
        { key: "phone", label: "電話", sortable: true },
        { key: "created_at", label: "申請時間", sortable: true },
        { key: "reject_btn", label: "", sortable: false }
      ],
      selectedList: []
    };
  },
  methods: {
    toUserDetail(item) {
      this.$store.commit("userDetail", item);
      this.$router.push({ name: "userDetail", params: { userId: item.id } });
    },
    async summit(item) {
      await this.$store.dispatch("postBlackUser", item);
      location.reload();
    },
    onRowSelected(items) {
      this.selectedList = items;
    },
    clearSelected() {
      this.$refs.selectableTable.clearSelected();
    },
    summitVerifyEmail() {
      this.$store.dispatch("postVerifyEmail", this.selectedList).then(() => {
        alert("核准信發送成功。");
      });
      // location.reload();
    }
  }
};
</script>

<style lang="scss" scoped>
.account-center-applying {
  .hidden {
    opacity: 0;
  }
}
::v-deep .table tbody .table-active {
  background-color: #bee5eb;
}
::v-deep {
  .table.b-table.table-hover > tbody > tr:hover td,
  .table.b-table.table-hover > tbody > tr:hover th,
  .table.b-table.table-hover > tbody > tr.table-active:hover td,
  .table.b-table.table-hover > tbody > tr.table-active:hover th {
    background-color: #343a40;
    color: #fff;
  }
}

// .table.table tbody tr:hover td {
// }
::v-deep .table tbody tr a {
  display: inline-block;
  width: 100%;
  cursor: pointer;
}
</style>
